export default "__VITE_ASSET__vu4mZA1l__"